(function () {
  const PARAM_KEY = 'key';
  const STORAGE_KEY = 'member_no';

  // -----------------------------
  // クエリパラメータ取得
  // -----------------------------
  function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  // -----------------------------
  // カートのattributesへ反映(サーバー側)
  // -----------------------------
  function updateCartAttribute(memberNo) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { member_no: memberNo }
      })
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('cart/update.js failed: ' + res.status);
        }
        return res.json();
      })
      .then(function (cart) {
        console.log('member_no reflected in cart attributes:', cart.attributes);
        return cart;
      })
      .catch(function (err) {
        console.error('Failed to update cart attribute:', err);
        return null;                      // ★変更: 失敗を呼び出し元に伝える
      });
  }

  // -----------------------------
  // 保存処理(クエリパラメータ検知時)
  // -----------------------------
  function saveMemberNo() {
    const memberNo = getQueryParam(PARAM_KEY);
    if (!memberNo) return Promise.resolve(false);

    try {
      localStorage.setItem(STORAGE_KEY, memberNo);
      console.log('member_no saved to localStorage:', memberNo);
    } catch (e) {
      console.error('Failed to save member_no to localStorage:', e);
    }

    return updateCartAttribute(memberNo).then(function (cart) {
      // ★修正: 成功したときだけ true を返す。
      //   失敗(null)なら false を返し、init 側で reapply にフォールバックさせる。
      return !!(cart && cart.attributes && cart.attributes.member_no === memberNo);
    });
  }

  // -----------------------------
  // localStorageにあれば毎ページロードで保証
  // -----------------------------
  function reapplyMemberNoIfNeeded() {
    let memberNo = null;
    try {                                           // ★変更: 例外ガード
      memberNo = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      console.error('Failed to read member_no from localStorage:', e);
    }
    if (!memberNo) return Promise.resolve();

    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        // 既にセット済みなら何もしない
        if (cart.attributes && cart.attributes.member_no === memberNo) {
          return;
        }
        // ★変更: item_count > 0 のガードを撤去
        //   空カートへの書き込みこそが保険の本体。
        //   カート生成前に確定させておくことでレースを減らす。
        return updateCartAttribute(memberNo);
      })
      .catch(function (err) {
        console.error('Failed to check cart state:', err);
      });
  }

  // -----------------------------
  // 初期実行
  // -----------------------------
  // ★変更: 並列実行をやめる
  //   旧コードは saveMemberNo() の POST と
  //   reapplyMemberNoIfNeeded() の GET が同時に飛び、
  //   カート未生成の初回訪問時に双方が別カートを生成して
  //   後着レスポンスの Set-Cookie が勝つ競合が起きていた。
  function init() {
    saveMemberNo().then(function (handled) {
      // ?key= を処理した直後は反映済みなので再確認は不要
      if (handled) return;
      return reapplyMemberNoIfNeeded();
    });
  }

  // ★変更: DOMContentLoaded 発火済みでも動くようフォールバック
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();